import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  ON_CUSTODY_CENTERS_LIST,
  ON_CUSTODY_CENTER_ADD,
  SCC_STOCKBALANCES_DATA,
  SCC_STOCKBALANCES_DATA_INIT,
  SCC_STOCK_HOLDING_DATA
} from "../constants/ActionTypes";
import {adminAPI} from 'util/Api';

export const initBalances = () => {
  return {
    type: SCC_STOCKBALANCES_DATA_INIT
  }
};

export const getCustodyCentersList = (payload) => {

  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    payload
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('safecustodycenters', _data
    ).then(({ data }) => {
      //console.log('Success');          
      if (data.length) {
        //console.log("Fetched SCC: ", data);
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: ON_CUSTODY_CENTERS_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      //console.log('Not executing this one', error); 
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
}

export const getCustodyCenter = (id) => {
  //console.log('Am here ',id);
  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.get('safecustodycenters/' + id, _data
    ).then(({ data }) => {
      //console.log('Success');          
      if (data.length) {
        //console.log("Fetched SCC: ", data);
        dispatch({ type: FETCH_SUCCESS });
        // format data and store them for use..
        dispatch({ type: ON_CUSTODY_CENTERS_LIST, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      //console.log('Not executing this one', error); 
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
}

export const createCustodyCenter = (newCustodyCenter) => {
  // console.log('CustodyCenter');
  // console.log(CustodyCenter);
  // console.log('CustodyCenter');
  let token = sessionStorage.getItem('token');

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('safecustodycenters', {
      REGION_ID: newCustodyCenter.REGION_ID,
      CUSTODY_CENTER_NAME: newCustodyCenter.CUSTODY_CENTER_NAME,
      BRANCH_CODE: newCustodyCenter.BRANCH_CODE,
      BOT_BRANCH: newCustodyCenter.BRANCH_CODE,
      CREATED_BY: JSON.parse(sessionStorage.getItem('user')).ID,
      UPDATED_BY: JSON.parse(sessionStorage.getItem('user')).ID
    }, _data
    ).then(({ data }) => {
      // console.log("data:", data);
      // console.log('success');
      sessionStorage.setItem("createResp", 'success');
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: ON_CUSTODY_CENTER_ADD, payload: newCustodyCenter });
    }).catch(function (error) {
      sessionStorage.setItem("createResp", 'error');
      dispatch({ type: FETCH_ERROR, payload: error.message });
      // console.log("Error****:", error.message);
    });
  }
};


export const getCustodyCenterBalances = (params = null) => {

  let token = sessionStorage.getItem('token');

  const _data = {
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };

  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    await adminAPI.get('stockbalances', _data
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      // format data and store them for use..
      dispatch({ type: SCC_STOCKBALANCES_DATA, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}


export const getCustodyCenterHolding = (params = null) => {

  let token = sessionStorage.getItem('token');

  const _data = {
    params: params,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };

  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    await adminAPI.get('centerStockHolding', _data
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      // format data and store them for use..
      dispatch({ type: SCC_STOCK_HOLDING_DATA, payload: data });
    }).catch((error) => {
      dispatch({ type: FETCH_ERROR, payload: error.message });
    });
  }
}